import { useState } from "react";
import { useParams } from "react-router-dom";
import ARDetails from "./ARDetails";
import ARContentUpload from "./ARContentUpload";
import ARModelUpload from "./ARModelUpload";
import TargetArea from "./TargetArea";
import AnchorPoints from "./AnchorPoints";

const ARModuleDetails = () => {
  const { moduleId } = useParams();
  const [showMediaContent, setShowMediaContent] = useState([]);
  const [threeDModelsList, setThreeDModelsList] = useState([]);

  return (
    <>
      <div className="detailspage container-fluid pb-3 ar-details">
          <div className="content-type">
            <ARDetails uuid={moduleId} setShowMediaContent={setShowMediaContent} threeDModelsList={threeDModelsList} />
            <ARContentUpload uuid={moduleId} />
            <ARModelUpload uuid={moduleId} setThreeDModelsList={setThreeDModelsList} />
            {showMediaContent.includes("cloudAnchor") && <AnchorPoints uuid={moduleId} />}
            {showMediaContent.includes("targetBased") && <TargetArea uuid={moduleId} /> }
          </div>
      </div>
    </>
  );
};

export default ARModuleDetails;